export default __webpack_public_path__ + "static/media/warning_black.0f083be0.svg";